// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1sVn4","title":"AfterBackImages_title__2CRQV","images":"AfterBackImages_images__2QH2r"};